'use client'; // Error components must be Client Components

import {Heading} from '@/components/heading';
import {Button} from '@/components/ui/button';
import {addReactError} from '@datadog/browser-rum-react';
import {useEffect} from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    // Log dell'errore su console o servizi esterni
    console.error('Errore catturato da error.tsx:', error);
    addReactError(error, {digest: error.digest});
  }, [error]);

  return (
    <div className="flex-1 flex flex-col justify-center items-center gap-10">
      <Heading variant="h2">
        Oops! Si è verificato un errore. Per favore, ricarica la pagina.
      </Heading>
      <Button onClick={() => window.location.reload()}>Ricarica</Button>
    </div>
  );
}
